import token from 'utils/token';
import camelizeKeys from 'utils/camelizeKeys';
import { buildUrl } from 'api/url';
import { setAuthorized } from 'slices/auth';

export const authorizationHeaders = () => (token.isValid ? { Authorization: `Bearer ${token}` } : {});
const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

const handleResponseStatus = (response, dispatch) => {
  const { status } = response;
  if (status === 401) {
    if (dispatch) {
      dispatch(setAuthorized(false));
    }
  }
  if (status >= 400) {
    throw new Error(status);
  }
};

const defaultHandler = async (response) => {
  const json = await response.json();
  return camelizeKeys(json);
};

const request = ({
  url, auth, method, credentials = 'same-origin', dispatch = null,
}) => async ({ body = null, handler = defaultHandler }) => {
  if (credentials !== 'include') {
    try {
      await refreshToken();
    }
    catch {
      if (!token.isValid) {
        dispatch(setAuthorized(false));
        return;
      }
    }
  }
  const headers = { ...jsonHeaders, ...authorizationHeaders() };
  const response = await fetch(buildUrl(url, auth), {
    method,
    headers,
    credentials,
    body: body ? JSON.stringify(body) : null,
  });
  handleResponseStatus(response, dispatch);
  const result = await handler(response);
  return result;
};

export const buildGet = (props) => async (handler) => request({
  ...props, method: 'GET',
})({ handler });

export const buildPost = (props) => async (body, handler) => request({
  ...props, method: 'POST',
})({ body, handler });

export const buildPatch = (props) => async (body, handler) => request({
  ...props, method: 'PATCH',
})({ body, handler });

export const refreshToken = async () => {
  if (token.isValid) return;

  const response = await buildPost({
    url: 'oauth/token',
    credentials: 'include',
  })({ grant_type: 'refresh_token' }, async (response) => response);

  if (response.status < 300) {
    const json = await response.json();
    const cJson = camelizeKeys(json);

    token.refresh(cJson);
  }
};
